import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TwoColumnSearchLayoutComponent } from './two-column-search-layout.component';
import {
  EmptyHideModule,
  PageContainerModule,
} from '@zelis/platform-ui-components';
import { DlsPaginationModule } from '@zelis/dls/pagination';
import { SerpLoaderModule } from '@components/serp-loader/serp-loader.module';

@NgModule({
  declarations: [TwoColumnSearchLayoutComponent],
  imports: [
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    PageContainerModule,
    DlsPaginationModule,
    EmptyHideModule,
    SerpLoaderModule,
  ],
  providers: [],
  exports: [TwoColumnSearchLayoutComponent],
})
export class TwoColumnSearchLayoutModule {}
